import json from "@/data/selected-work-copy.generated.json";
import { createCopyGetter } from "./localize-copy";

export const getSelectedWorkCopy = /*#__PURE__*/ createCopyGetter(json);
